// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import { WorkbookVariantFragmentFragmentDoc } from "../../Workbook/gql/Fragment.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CreateWorkbookResultMutationVariables = Types.Exact<{
  variantId: Types.Scalars["ID"]["input"];
  explainText?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  explainJson?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  parameterSetId?: Types.InputMaybe<Types.Scalars["ID"]["input"]>;
}>;

export type CreateWorkbookResultMutation = {
  __typename?: "Mutation";
  createWorkbookResult: {
    __typename?: "WorkbookVariant";
    id: string;
    createdAt: number;
    updatedAt: number;
    description?: string | null;
    queryFingerprint: string;
    queryText: string;
    name: string;
    queryTextWithAlias: string;
    paramRefAliasMap: any;
    draft: boolean;
    plannerSettings: any;
    appliedInsights?: any | null;
    workbookResults: Array<{
      __typename?: "WorkbookResult";
      id: string;
      format: string;
      resultSource: string;
      createdAt: number;
      updatedAt: number;
      status?: string | null;
      errorMessage?: string | null;
      totalCost?: number | null;
      totalSharedBlksHit?: number | null;
      totalSharedBlksRead?: number | null;
      totalSharedBlksWritten?: number | null;
      totalSharedBlksDirtied?: number | null;
      totalBlkReadTime?: number | null;
      totalBlkWriteTime?: number | null;
      planNodeTypes?: Array<string | null> | null;
      runtimeMs?: number | null;
      planFingerprint?: string | null;
      parameterSetId?: string | null;
      nodeInsights?: any | null;
      user?: {
        __typename?: "User";
        id: string;
        fullname?: string | null;
      } | null;
    }>;
    user?: { __typename?: "User"; id: string; fullname?: string | null } | null;
    queryTextWithParameters: Array<{
      __typename?: "QueryTextWithParameters";
      id: string;
      parameterSetId: string;
      queryWithParameters: string;
    }>;
  };
};

export const CreateWorkbookResultDocument = gql`
  mutation CreateWorkbookResult(
    $variantId: ID!
    $explainText: String
    $explainJson: String
    $parameterSetId: ID
  ) {
    createWorkbookResult(
      variantId: $variantId
      explainText: $explainText
      explainJson: $explainJson
      parameterSetId: $parameterSetId
    ) {
      ...WorkbookVariantFragment
    }
  }
  ${WorkbookVariantFragmentFragmentDoc}
`;
export type CreateWorkbookResultMutationFn = Apollo.MutationFunction<
  CreateWorkbookResultMutation,
  CreateWorkbookResultMutationVariables
>;

/**
 * __useCreateWorkbookResultMutation__
 *
 * To run a mutation, you first call `useCreateWorkbookResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkbookResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkbookResultMutation, { data, loading, error }] = useCreateWorkbookResultMutation({
 *   variables: {
 *      variantId: // value for 'variantId'
 *      explainText: // value for 'explainText'
 *      explainJson: // value for 'explainJson'
 *      parameterSetId: // value for 'parameterSetId'
 *   },
 * });
 */
export function useCreateWorkbookResultMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateWorkbookResultMutation,
    CreateWorkbookResultMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateWorkbookResultMutation,
    CreateWorkbookResultMutationVariables
  >(CreateWorkbookResultDocument, options);
}
export type CreateWorkbookResultMutationHookResult = ReturnType<
  typeof useCreateWorkbookResultMutation
>;
export type CreateWorkbookResultMutationResult =
  Apollo.MutationResult<CreateWorkbookResultMutation>;
export type CreateWorkbookResultMutationOptions = Apollo.BaseMutationOptions<
  CreateWorkbookResultMutation,
  CreateWorkbookResultMutationVariables
>;
